import { Input, Message, Modal } from '@bitcine/cinesend-theme/dist'
import { useState } from 'react'

const DeleteConfirmationModal = ({ cycle, errors, onClose, onConfirm }) => {
  const [airlineGroupCode, setAirlineGroupCode] = useState('')

  return (
    <Modal
      header={'Confirm Cycle Deletion'}
      onClose={() => onClose()}
      confirmButton={{
        type: 'error',
        text: 'Confirm',
        onClick: () => onConfirm(cycle?.id, airlineGroupCode),
        disabled: !airlineGroupCode || airlineGroupCode !== cycle?.airline.group_code,
      }}
      className='max-w-96'
    >
      <p>
        Are You Sure you want to delete cycle <span className='font-bold'>{cycle?.name}</span>?
      </p>
      <p className='pb-4'>{cycle?.description}</p>
      <Input
        label={`Enter the Group Code to delete`}
        value={airlineGroupCode}
        onChange={(e) => setAirlineGroupCode(e.target.value)}
        autoFocus
      />
      <br />
      {errors && (
        <Message info={true} small={true} className='h-auto'>
          <ul className={errors.length > 1 ? 'list-disc list-inside' : 'list-none'}>
            {errors.map((error, index) => (
              <li className='' key={`cycle-deletion-${index}`}>
                {error}
              </li>
            ))}
          </ul>
        </Message>
      )}
    </Modal>
  )
}

export default DeleteConfirmationModal
